import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Alerts.css";
import { Button, Col, Row, Radio, Dropdown, Form, Menu, Checkbox } from "antd";
import {
  AlignLeftOutlined,
  CalendarOutlined,
  CaretDownFilled,
  DownloadOutlined,
  FilterOutlined,
  MinusOutlined,
  PlusOutlined,
  RedoOutlined,
  SearchOutlined,
  SettingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import Absence from "./Absence";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import images1 from "../../assets/images1.jfif";
import {
  BASE_URL,
  FetchAttendanceAlertView,
  FetchDepartment,
  FetchDesignation,
} from "../../utils/constant";
import moment from "moment";
import { useSelector } from "react-redux";
import { ExportToExcel } from "../../common/ExportToExcel";
import Refresh from '../../assets/icons/refresh.svg';
import Filter from '../../assets/icons/filter-box.svg';

const { RangePicker } = DatePicker;
function Alerts() {
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const designationState = useSelector((state) => state.designation.designation);
  const departmentState = useSelector((state) => state.department.department);

  const [dates, setDates] = useState([dayjs(new Date()), dayjs(new Date())]);
  const [fromDate, setFromDate] = useState(
    moment(dates[0]).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(moment(dates[1]).format("YYYY-MM-DD"));
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const gridRef = useRef([]);
  const [value, setValue] = useState(null);
  const [size, setSize] = useState("");
  const [departments, setDepartments] = useState(departmentState);
  const [designations, setDesignations] = useState(designationState);
  const [selectedFilters, setSelectedFilters] = useState({
    designation: [],
    department: [],
  });
  const [size1, setSize1] = useState("july1");
  const [alertData, setAlertData] = useState([]);
  const [alertExportData, setAlertExportData]= useState([])

  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const calculateShiftDuration = (shiftStartTime, shiftEndTime) => {
 
    const milliseconds_in_a_day = 24 * 60 * 60 * 1000;
    let shiftDuration;
  
    if (shiftStartTime <= shiftEndTime) {
        shiftDuration = shiftEndTime - shiftStartTime;
    } else {
        shiftDuration = milliseconds_in_a_day - shiftStartTime + shiftEndTime;
    }
  
    return shiftDuration;
  }
  useEffect(() => {
    getStaffAlertList();
  }, [toDate, fromDate]);
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      'quickFilterText',
      document.getElementById('filter-text-box').value
    );
  }, []);
  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };

  const getStaffAlertList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchAttendanceAlertView}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          fromDate: fromDate,
          toDate: toDate,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setAlertData(data?.data?.staffAttendance);
      } else {
        const data = await response.json();
        console.log("stafTodayerr", data);
        // toast.error(data.errorMessage, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      }
    };

    await fetchData();
  };

  const disabledDate = (current) => {
    
    const BoCreatedAt = userInfo?.userRole === "businessOwner" ? userInfo?.createdAt : userInfo?.boOwner?.createdAt;
    const disableBefore = moment(BoCreatedAt);
    const oneDayBeforeBoCreatedAt = disableBefore.subtract(1, 'days');

    const disableAfter = moment().endOf('day'); // Today's end date
    
    const maxSelectableEndDate = moment(dates[0].$d).add(30, 'days').endOf('day');
    
    return current && (
      current < oneDayBeforeBoCreatedAt || 
      current > disableAfter ||
      (dates.length > 0 && current > maxSelectableEndDate)
    );
   
  };

  const onOpenChange = (open) => {
    // if (open) {
    //   setDates([null, null]);
    // } else {
    //   setDates(dates);
    // }
  };
  function formatTime(milliseconds) {
    if (milliseconds > 0) {
      const hours = Math.floor(milliseconds / 3600000);
      const minutes = Math.round((milliseconds % 3600000) / 60000);

      if (hours > 0) {
        return `${hours}:${minutes < 10 ? "0" : ""}${minutes} hr`;
      } else {
        return `${minutes} min`;
      }
    }
  }
  function formatTimeWithAMPM(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  }
  const formatDate = (timestamp) => {
    const dateObject = new Date(timestamp);

    const options = { year: "numeric", month: "short", day: "numeric" };
    return dateObject.toLocaleDateString("en-US", options);
  };
  
  const columnDefs = [
    {
      field: "name",
      headerName: "Name",
      
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
      }),
      cellRenderer: (params) => {
        return (
          <div className="flex items-center">
            <img
              className="image"
              style={{ width: "47px", height: "47px" }}
              src={params.data?.item?.staffDetails?.faceRegisterUrl || params.data?.item?.staffDetails?.logo}
              alt=""
            />
            <div className="!ml-3">
              <p  className="text-[15px] font-sbold">
                {capitalizeFirstLetter(
                  params.data?.item?.staffDetails?.firstName
                )}{" "}
                {capitalizeFirstLetter(
                  params.data?.item?.staffDetails?.lastName
                )}
              </p>
              <p className="text-xs">
                {capitalizeFirstLetter(
                  params.data?.item?.staffDetails?.designationName
                )}
              </p>
            </div>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      width: 130,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
      }),
    },
    {
      field: "planned",
      headerName: "Planned",
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="text-[15px]">
            <p>
              Location: {capitalizeFirstLetter(params.data?.planned)}
            </p>
            <p>
              Shift:{" "}
              {capitalizeFirstLetter(
                params.data.item?.planShiftDetails?.shiftShortName
              )}{" "}
              (
              {formatTimeWithAMPM(
                params.data.item?.planShiftDetails?.shiftStartTime
              )}{" "}
              -{" "}
              {formatTimeWithAMPM(
                params.data.item?.planShiftDetails?.shiftEndTime
              )}
              )
            </p>
            <div className="flex justify-between">
              <p>
                WH:{" "}
                {formatTime(calculateShiftDuration(
                  params.data.item?.planShiftDetails?.shiftStartTime,
                  params.data.item?.planShiftDetails?.shiftEndTime
                ))}
              </p>
            </div>
          </div>
        );
      },
    },
    {
      field: "actual",
      headerName: "Actual",
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="text-[15px] w-full">
            <p>
              Location:{" "}
              {params.data?.item?.checkInTime
                ? params.data.item?.checkinLocation.locationId
                  ? capitalizeFirstLetter(
                      params.data.item?.checkinLocation.locationName1
                    )
                  : "Unknown Location"
                : "---"}
            </p>
            <p>
              {params.data?.item?.checkInTime !== undefined && 
              formatTimeWithAMPM(params.data?.item?.checkInTime) !== undefined
                ? formatTimeWithAMPM(params.data?.item?.checkInTime)
                : "---"}{" "}
              -{" "}
              {params.data?.item?.checkOutTime !== undefined && 
              formatTimeWithAMPM(params.data?.item?.checkOutTime) !== undefined
                ? formatTimeWithAMPM(params.data?.item?.checkOutTime)
                : "---"}
            </p>
            <div className="flex justify-between">
              <p>
                OT/LT:{" "}
                {params.data?.item?.isAbsent == false
                  ? params.data.item?.staffOtTime > 0
                    ? formatTime(params.data.item?.staffOtTime)
                    : formatTime(params.data.item?.staffLtTime)
                  : "---"}
              </p>
              <p>
                WH:{" "}
                {params.data?.item?.totalWorkingHr 
                  ? formatTime(params.data?.item?.totalWorkingHr)
                  : "---"}
              </p>
            </div>
          </div>
        );
      },
    },
   
  ];

  
  const filteredData = alertData.filter((item) => {
    const isDepartmentMatch =
      selectedFilters.department.length === 0 ||
      selectedFilters.department.includes(item.staffDetails.departmentId);
    const isDesignationMatch =
      selectedFilters.designation.length === 0 ||
      selectedFilters.designation.includes(item.staffDetails.designationId);

    let additionalFilter = true;

    switch (size) {
      case "isAbsent":
        additionalFilter = item.isAbsent;
        break;
      case "isWrongLocation":
        additionalFilter = item.isWrongLocation;
        break;
      case "isimage":
        additionalFilter = item.isimage;
        break;
      case "isStaffLate":
        additionalFilter = item.isStaffLate || item.isStaffEarly;
        break;
      case "isStaffOverTime":
        additionalFilter = item.isStaffOverTime;
        break;
      case "isStaffLessTime":
        additionalFilter = item.isStaffLessTime;
        break;
      default:
        additionalFilter = true; 
    }
    return additionalFilter && isDepartmentMatch && isDesignationMatch;
  });
  const rowData = filteredData 
    .map((item, index) => ({
      key: index.toString(),
      item: item,
      name: item?.staffDetails?.firstName,
      date: formatDate(item.attendanceDate),
      absent: item.absent,
      planned: item.planlocationDetail
        ?.map((item) => item.locationName2)
        .join(", "),
      actual: item.actual,
      photos: item.photos,
    }));

    useEffect(() => {
      const transformedData = filteredData?.length > 0 && filteredData?.map(item => ({
        name: `${item?.staffDetails?.firstName} ${item?.staffDetails?.lastName}`,
        designation: item?.staffDetails?.designationName,
        Date: formatDate(item?.attendanceDate), 
        location: item?.planlocationDetail?.map(loc => loc.locationName2).join(", "),
        ShiftName: item?.planShiftDetails?.shiftShortName,
        Timing: `${formatTimeWithAMPM(
          item?.planShiftDetails?.shiftStartTime
        )} - ${formatTimeWithAMPM(
          item?.planShiftDetails?.shiftEndTime
        )}`,
        checkinTime: item?.checkInTime !== undefined && 
        formatTimeWithAMPM(item?.checkInTime) !== undefined
          ? formatTimeWithAMPM(item?.checkInTime) : '--', 
        checkOutTime: item?.checkOutTime !== undefined && 
        formatTimeWithAMPM(item?.checkOutTime) !== undefined
          ? formatTimeWithAMPM(item?.checkOutTime) : '--',
        OtTime:  item?.isAbsent == false
                  ? item?.staffOtTime > 0
                    ? formatTime(item?.staffOtTime)
                  : "---" : "---",
        LtTime:  item?.isAbsent == false
                  ? item?.staffLtTime > 0
                    ? formatTime(item?.staffLtTime)
                  : "---" : "---"
      }));
      console.log('transformedData',transformedData)
      setAlertExportData(transformedData);
    
  },[selectedFilters,size,alertData]);
  const handleSizeChange = (e) => {
    setSize(e.target.value);
  };
  const handleSizeChange1 = (e) => {
    setSize1(e.target.value);
  };
  
  const onDateChange = (dates) => {
    if (dates.length > 0) {
      setFromDate(moment(dates[0].$d).format("YYYY-MM-DD"));
      setToDate(moment(dates[1].$d).format("YYYY-MM-DD"));
      setDates([dates[0], dates[1]]);
      
    }
  };
  const removeAllFilter = () => {
    setSize("");

    setSelectedFilters({
      designation: [],
      department: [],
    });
  };
 

  const filters = {
    designation: designations,
    department: departments,
  };

  const handleFilterMenuClick = (type, { key }) => {
   
    const updatedSelection = selectedFilters[type].includes(key)
      ? selectedFilters[type].filter((item) => item !== key)
      : [...selectedFilters[type], key];
    setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
  };

  const filterMenu = (type) => (
    <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
      {filters[type].map((filter) => (
        <Menu.Item key={filter.key} >
            <Checkbox
              checked={selectedFilters[type].includes(filter.key)}
              className="mr-1"
            />
            {filter.value}
          
        </Menu.Item>
      ))}
    </Menu>
  );
  const dropdownMenu = (
    <Menu>
      <Menu.SubMenu key="designation" title="Designation">
        {filterMenu("designation")}
      </Menu.SubMenu>
      <Menu.SubMenu key="department" title="Department">
        {filterMenu("department")}
      </Menu.SubMenu>
    </Menu>
  );

  return (
    <div className="p-3">
      <Row>
        <Col lg={24}>
          <div className="flex flex-wrap align-items-center justify-content-between">
            <div className="flex align-items-center flex-wrap alertstab">
                <input
                  type="text"
                  id="filter-text-box"
                  className="h-[39px] border-[2px] border-[#99ACBF] rounded-lg !px-4 text-sm mr-3 w-44"
                  placeholder="Search..."
                  onChange={onFilterTextBoxChanged}
                />
             <img src={Refresh} onClick={removeAllFilter} className="cursor-pointer"/>
              
              <Radio.Group
                value={size}
                onChange={handleSizeChange}
                className="flex flex-wrap ml-2"
              >
                <Radio.Button className="m-1" value="isAbsent">
                  Absence
                </Radio.Button>
                <Radio.Button className="m-1" value="isWrongLocation">
                  <p>Location</p>
                </Radio.Button>
                <Radio.Button className="m-1" value="isStaffLate">
                  Wrong Time
                </Radio.Button>
                <Radio.Button className="m-1" value="isStaffOverTime">
                  Overtime
                </Radio.Button>
                <Radio.Button className="m-1" value="isStaffLessTime">
                  Less time
                </Radio.Button>
              </Radio.Group>
            </div>
            
            <div className="flex flex-wrap ml-10">
              <Dropdown
                overlay={dropdownMenu}
                trigger={["click"]}
                placement="bottom"
              >
                <img src={Filter} className="cursor-pointer"/>
              </Dropdown>
              <RangePicker
                className="rangepickerAlter ml-3 mr-3"
                value={dates}
                suffixIcon={null}
                allowClear={false}
                disabledDate={disabledDate}
               
                onChange={(val) => {
                  onDateChange(val);
                }}
                onOpenChange={onOpenChange}
                changeOnBlur
              />

             
                        {filteredData?.length > 0 && 
                          <ExportToExcel apiData={alertExportData} fileName={"AlertAttendanceData"} />
                        }
            </div>
          </div>
        </Col>
        <Col lg={14}>
          <div
            className="ag-theme-alpine text-base border-none font-proxima tableBordered"
            style={{ width: "100%", marginTop: "40px" }}
          >
         
            <AgGridReact
              columnDefs={columnDefs}
              rowData={rowData}
              pagination={true}
              paginationPageSize={20}
              domLayout="autoHeight"
              getRowHeight={() => 80} 
              enableSorting={true}
              enableFilter={true}
              floatingFilter={true}
              ref={gridRef}
              paginationPageSizeSelector={false}
            />
          </div>
        </Col>
       
      </Row>
      

      <div className="mt-5">
        {/* <Absence /> */}
      </div>
    </div>
  );
}

export default Alerts;
